import { action } from 'mobx';
import { LoginForm } from 'application/membership/forms';
import { BaseViewStore } from 'core/stores';

class LoginViewStore extends BaseViewStore {
    routes = {
        forgotPassword: () => this.rootStore.routerStore.goTo('master.app.membership.password-recovery'),
        register: () => this.rootStore.routerStore.goTo('master.app.membership.register')
    };

    loaderStore = this.createLoaderStore();
    loginForm = new LoginForm({
        onSuccess: async (form) => {
            const { email, password } = form.values();
            await this.login({
                username: email,
                password
            });
        },
    });

    constructor(rootStore) {
        super();

        this.rootStore = rootStore;
        this.app = rootStore.application.baasic;
    }

    @action
    async login({ username, password }) {
        this.loaderStore.suspend();
        try {
            try {
                await this.app.membershipModule.login.login({ username, password, options: ['sliding']});
            } catch (ex) {
                if (ex.statusCode !== 401) {
                    throw ex;
                }
                await this.loginWithoutStaleToken({ username, password });
            }
            await this.rootStore.userStore.resolveUser();
            const redirect = this.rootStore.authStore.getSignInRedirect();
            await this.rootStore.routerStore.goTo(redirect);
        } catch (ex) {
            const { statusCode, data } = ex;
            if (statusCode === 400) {
                if (data.error === 'invalid_grant') {
                    this.loginForm.invalidate('Invalid email or password');
                }
                else if (data.error === 'invalid_grant_lock') {
                    this.loginForm.invalidate('User is locked');
                }
                else if (data.error === 'invalid_grant_approve'){
                    this.loginForm.invalidate('User is not approved');
                }
            }
            this.loaderStore.resume();
        }
    }

    // A stale token left in storage (e.g. after a username change invalidated it server-side) is attached
    // as a Bearer header by the API client and makes the login request itself return 401. Drop it without
    // firing token events, so other open tabs are not signed out, and retry the login anonymously.
    async loginWithoutStaleToken({ username, password }) {
        this.app.tokenHandler.store(null, { skipTokenEvents: true });
        await this.app.membershipModule.login.login({ username, password, options: ['sliding']});
    }

    @action.bound
    async logout() {
        if(!this.app.getAccessToken()){
            return;
        }
        const { token, type } = this.app.getAccessToken();

        try {
            const url = uritemplate.parse('login').expand({}); // eslint-disable-line
            await this.app.apiClient.delete(url, null, {
                token,
                type
            });
            this.app.updateAccessToken(null);
        } catch (ex) {
            // handle unsuccessful logout
        }
    }
}

export default LoginViewStore;
